import { createAvailabilityApiClient } from '@/scopes/prices/infrastructure/availability/availabilityApiClient'

export const availabilityApiClient = createAvailabilityApiClient({})
